import React, { useEffect, useState } from 'react';
import {useCpfCnpj} from './useCpfCnpj';
import {Input} from 'antd';



const InputCpfCnpj = (props) => {

    const [maskedValue, setMaskedValue] = useState('');
    const {validaCpfCnpj, cpfcnpjMask, cpfcnpjMaskUnMask } = useCpfCnpj();

    
    const [value, setValue] = useState({value: '', maskedValue: ''});

    const {onChange, setCpfCnpjValido, onBlur} = props;

    

    
    const onChangeThis = (evt) => {
        const newMaskedValue = cpfcnpjMask(evt.target.value);
        const newValue = cpfcnpjMaskUnMask(newMaskedValue);

        const newValido = validaCpfCnpj(newValue);
        
        setMaskedValue(newMaskedValue);
        setValue({value: newValue, maskedValue});

        let statusValidacao = "success";
        if(!newValido.valido){
            statusValidacao = "error"
        }
        console.log(statusValidacao);
        setCpfCnpjValido && setCpfCnpjValido(newValido);
        onChange && onChange({
            target: {value: newValue}
        });
    }
    
   
   

    return <Input 
                onChange={onChangeThis} 
                value={maskedValue}
                onBlur={onBlur}
            >    
            </Input>;
    

    
};

export {InputCpfCnpj};